import { Box, CircularProgress, Typography } from '@mui/material';

const ContainerLoading = ({
  additionalLoadingText,
  height = '100%',
  marginTop = 0,
  spinnerOnTop = false,
  spinnerSize = 25,
}: {
  height?: string | number;
  additionalLoadingText?: string;
  marginTop?: number;
  spinnerOnTop?: boolean;
  spinnerSize?: number;
}) => {
  const label = `Loading${additionalLoadingText ? ` ${additionalLoadingText}` : ''}...`;
  const containerStyles = spinnerOnTop
    ? {
        height: height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: marginTop ? 'flex-start' : 'center',
        gap: 2,
        marginTop,
      }
    : {
        height: height,
        display: 'flex',
        flexDirection: 'row',
        alignItems: marginTop ? 'flex-start' : 'center',
        justifyContent: 'center',
        gap: 1,
        marginTop,
      };

  return (
    <Box sx={containerStyles}>
      <CircularProgress
        aria-label={label}
        size={spinnerSize}
        sx={{ color: 'primary.main' }}
      />
      <Typography>{label}</Typography>
    </Box>
  );
};

export default ContainerLoading;
